// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__4ifhK","logo":"style__logo__vUi4F"};